import { keepPreviousData, useQuery } from "@tanstack/react-query";

import relationService from "@services/relation.service";
import { OBJECT_TAGS_QUERY_KEY, QUERY_CACHE_SHORT_EXPIRATION_MS } from "@config/query";
import { DEBOUNCE_MS } from "@config/constants";
import { ITagResponse } from "@interfaces/responses.interface";

export const searchFn = async (signal: AbortSignal, contentType: string, objectId: string) => {
  return new Promise<ITagResponse[]>((resolve, reject) => {
    const timeout = setTimeout(() => {
      relationService
        .getCurrentTags(contentType, objectId)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }, DEBOUNCE_MS);

    signal.addEventListener("abort", () => {
      clearTimeout(timeout);
      reject(new Error("Aborted"));
    });
  });
};

export function useGetTags(contentType: string, objectId: string) {
  return useQuery({
    enabled: Boolean(contentType && contentType.length > 0 && objectId && objectId.length > 0),
    queryKey: [OBJECT_TAGS_QUERY_KEY, contentType, objectId],
    queryFn: ({ signal }) => searchFn(signal, contentType, objectId),
    staleTime: QUERY_CACHE_SHORT_EXPIRATION_MS,
    retry: false,
    placeholderData: keepPreviousData,
  });
}
